export const selectMockData = (state) => state.editorMockButton?.mockData;

export const selectShowDialog = (state) => state.editorMockButton?.showDialog;
